import { makeAjaxRequest } from "./createAjaxActions";

const stores = {
  USERS: {
    keyField: "Username",
    tb: "Users",
  },
  VENUES: {
    keyField: "venueId",
    tb: "Venues",
  },
};

export function fetchData(name, options) {
  return makeAjaxRequest(
    name,
    {
      command: stores[name].fetchCommand || "entries.list",
      ...options,
      tb: stores[name].tb || name,
    },
    "FETCH"
  );
}

export function createLocalRecord(name, data, addLast) {
  return {
    data,
    type: `CREATE_LOCAL_${name}`,
    addLast,
  };
}

export function updateLocalRecord(name, guid, field, value) {
  return {
    type: `UPDATE_LOCAL_${name}`,
    guid,
    field,
    value,
  };
}

export function removeRecord(name, record) {
  return makeAjaxRequest(
    name,
    {
      command: stores[name].removeCommand || "entry.remove",
      guid: record[stores[name].keyField] || "GUID",
      tb: stores[name].tb || name,
    },
    "DELETE"
  );
}

export function createRecord(name, data, addLast, callback = null) {
  return makeAjaxRequest(
    name,
    {
      command: stores[name].createCommand || "entry.add",
      data: JSON.stringify(data),
      addLast,
      tb: stores[name].tb || name,
    },
    "INSERT",
    data,
    callback
  );
}

export function updateRecord(name, id, field, value, old, callback = null) {
  return makeAjaxRequest(
    name,
    {
      command: stores[name].updateCommand || "entry.update",
      id,
      updates: {
        [field]: value,
      },
      tb: stores[name].tb || name,
    },
    "UPDATE",
    null,
    callback
  );
}

export function multiUpdateRecord(name, id, updates) {
  return makeAjaxRequest(
    name,
    {
      command: stores[name].updateCommand,
      id,
      updates: JSON.stringify(updates),
    },
    "MULTIUPDATE",
    updates
  );
}

export function updateLinkTable(
  name,
  groupGuid,
  groupField,
  itemGuids,
  itemField
) {
  return makeAjaxRequest(
    name,
    {
      command: "linktable.update",
      table: stores[name].table,
      groupGuid,
      groupField,
      itemGuids,
      itemField,
    },
    "LINK_UPDATE"
  );
}
export function updateSequence() {}
